module.exports = __webpack_public_path__ + "static/media/fail.c8e28614.png";